export const IOS_URL = import.meta.env.PUBLIC_ENV__IOS_URL;
export const EXTENSION_URL = `https://chrome.google.com/webstore/detail/dinosave/${import.meta.env.PUBLIC_ENV__EXTENSION_ID}`;
